var e = {
	success: {
		title: "Payment Received",
		confirmingBody: "Confirming your booking — this usually takes just a moment.",
		delayedBody: "Your payment went through. Preparing your booking is taking a little longer than usual — it will appear in your trips shortly.",
		viewTrips: "View my trips"
	},
	failed: {
		title: "Payment unsuccessful",
		body: "Your payment didn't go through and you haven't been charged. You can try booking again or check your existing trips.",
		myTrips: "My trips",
		browseStays: "Browse stays",
		heldTitle: "Your dates are still held",
		heldBody: "You haven't been charged. These dates are held until {{date}} — you can pay with a different card.",
		stayDates: "{{checkIn}} – {{checkOut}}",
		total: "Total {{amount}}",
		switchTitle: "Try another way to pay",
		switchSubtitle: "Pick the checkout that matches the card you're using.",
		releasedTitle: "This checkout has expired",
		releasedBody: "You haven't been charged. The dates have been released back to the calendar — search again to book them.",
		searchAgain: "Search again",
		loadingContext: "Checking whether the dates are still held…",
		holdLine: "{{listing}} · {{checkIn}} – {{checkOut}} · {{amount}}"
	},
	nativeReturn: {
		successTitle: "Payment complete",
		failedTitle: "Payment not completed",
		successBody: "Your trip is being confirmed in the Maat app.",
		failedBody: "You haven't been charged. You can try again in the Maat app.",
		closeHint: "Close this screen to go back to the app.",
		returnToApp: "Return to the app"
	},
	bookingLine: {
		avatarFallback: "Booking",
		bookingRef: "Booking {{ref}}"
	},
	debtActions: {
		title: "Settle penalty",
		payFromBalance: "Pay from balance",
		payFromBalanceHint: "Settles {{covered}} now from your {{available}} available balance.",
		noBalanceHint: "No available balance to apply.",
		payByCard: "Pay by card",
		payByCardHint: "Pay {{amount}} by card.",
		whyTitle: "Why am I seeing this?",
		whyBody: "Cancellation penalties are charged when you cancel a confirmed booking. Listings stay suspended until the balance is cleared.",
		paymentApplied: "Payment applied",
		paymentAppliedDescription: "{{amount}} settled from your balance.",
		paymentFailed: "Payment failed",
		cardStartFailed: "Couldn't start card payment",
		cardReceived: "Payment received",
		cardReceivedDescription: "Your penalty is being settled — this can take a moment to reflect."
	},
	debtSummary: {
		title: "Outstanding penalties",
		cleared: "Cleared",
		actionRequired: "Action required",
		totalOwed: "TOTAL OWED",
		penaltyCount_one: "PENALTY",
		penaltyCount_other: "PENALTIES ({{count}})",
		cancellationPenalty: "Cancellation penalty",
		listingRef: "Listing {{ref}}"
	},
	eligibleBooking: { available: "Available {{date}}" },
	penaltyTimeline: {
		title: "Settlement activity",
		notSettled: "Not settled yet."
	},
	penaltySummary: {
		title: "Penalty",
		outstanding: "OUTSTANDING",
		totalPenalty: "TOTAL PENALTY",
		penaltyCharged: "Penalty charged",
		paidToDate: "Paid to date",
		outstandingRow: "Outstanding",
		recorded: "Recorded",
		settled: "Settled"
	},
	requestWithdrawal: {
		title: "Request Withdrawal",
		subtitle: "Select the bookings you want to be paid out for. Each booking is paid in full.",
		noMethodMessage: "Add a withdrawal method before requesting a payout",
		addMethod: "Add Withdrawal Method",
		methodLabel: "Withdrawal method",
		methodPlaceholder: "Select a withdrawal method",
		eligibleBookings: "Eligible bookings",
		noEligibleBookings: "No bookings are available for payout yet",
		chooseMethodFirst: "Choose a payout destination first — it decides which currency this withdrawal is in.",
		selectedCount: "{{count}} selected",
		submit: "Submit Request",
		requested: "Withdrawal requested",
		requestFailed: "Failed to request withdrawal",
		requestFailedDescription: "Something went wrong. Please try again."
	},
	addCard: {
		title: "Add a card",
		verificationTitle: "Card verification — not a charge",
		verificationBody: "We temporarily authorize EGP 1.00 to verify your card. It's not a charge and is refunded back to you automatically.",
		setupFailed: "Couldn't start card setup. Please try again."
	},
	savedCards: {
		title: "Saved cards",
		description: "Cards you can use at checkout.",
		empty: "No payment methods yet — add a card to speed up checkout.",
		removeCardLabel: "Remove card",
		addPaymentMethod: "Add payment method",
		removeFailed: "Failed to remove card",
		removeConfirmTitle: "Remove card?",
		removeConfirmDescription: "This card will be removed from your account. You can add it again later.",
		removeConfirm: "Remove",
		default: "Default",
		savedCard: "Saved card"
	},
	withdrawalActions: {
		title: "Actions",
		cancelWithdrawal: "Cancel withdrawal",
		noActions: "No actions available for a {{status}} withdrawal.",
		cancelled: "Withdrawal cancelled",
		cancelFailed: "Could not cancel withdrawal",
		cancelConfirmTitle: "Cancel this withdrawal?",
		cancelConfirmDescription: "The reserved funds will return to your available balance."
	},
	withdrawalBookings: { title: "Bookings ({{count}})" },
	withdrawalDestination: {
		title: "Destination",
		unavailable: "Withdrawal method unavailable"
	},
	withdrawalSummary: {
		title: "Withdrawal",
		total: "TOTAL",
		requested: "REQUESTED",
		updated: "UPDATED",
		bookings: "BOOKINGS",
		reference: "REFERENCE",
		notes: "NOTES"
	},
	paymob: {
		loading: "Preparing checkout…",
		error: "Failed to initialize payment. Please try again."
	},
	checkout: {
		loading: "Preparing checkout…",
		error: "Failed to initialize payment. Please try again.",
		pay: "Pay now",
		declined: "That payment didn't go through. Check the card details, or try another card.",
		chooseTitle: "How would you like to pay?",
		chooseSubtitle: "Both are secure. Pick the one that matches the card you're using.",
		chargedInCurrency: "Your card will be charged in {{currency}}.",
		startFailedTitle: "Couldn't start checkout",
		startFailedBody: "We couldn't reach the payment provider. Please try again in a moment.",
		notReadyBody: "We can't start this checkout right now. Your dates are still held — try again in a moment, and update the app if it keeps happening.",
		retry: "Try again",
		appUpdateRequired: "Update the app to pay with an international card. You can still pay with an Egyptian card."
	},
	admin: {
		webhookInbox: {
			title: "Payment Inbox",
			subtitle: "Every callback Paymob and Stripe have sent, and what became of it. This is where a charge that never became a booking is found.",
			payloadNotice: "The stored callback is never shown here. A parked delivery still holds the payer's billing details and their masked card number — what it could not tell us is in its reason; what it contains is somebody's payment identity.",
			retryNotice: "Retry re-runs the drain over one parked callback, which can write ledger entries and ask the processor for a refund. It is recorded against your account. A settled callback cannot be retried at all.",
			stats: {
				parked: "Parked",
				parkedHint: "Waiting on a human. The drain will not touch these again on its own.",
				retrying: "Retrying",
				retryingHint: "Parked once, re-opened, and being run again.",
				pending: "Awaiting the drain",
				pendingHint: "Captured, never attempted. Seconds, normally.",
				processed: "Settled",
				processedHint: "Drained. Most of this table, and part of the answer.",
				oldest: "Oldest unresolved",
				oldestNone: "Nothing waiting",
				dlqDepth: "Dead-lettered",
				dlqDepthHint: "Messages parked on the broker queue.",
				dlqUnavailable: "Unknown — the service could not be reached.",
				paymob: "From Paymob",
				stripe: "From Stripe",
				providerHint: "Callbacks captured, all states."
			},
			filters: {
				allStatuses: "Any status",
				allProviders: "Any processor",
				allKinds: "Any kind"
			},
			status: {
				PENDING: "Pending",
				PROCESSED: "Settled",
				NEEDS_REVIEW: "Parked",
				FAILED: "Failed"
			},
			provider: {
				paymob: "Paymob",
				stripe: "Stripe"
			},
			kind: {
				SUCCESS: "Payment",
				REFUND: "Refund",
				VOID: "Void",
				REFUNDED: "Refunded",
				DECLINED: "Declined",
				REVIEW: "Unclassified"
			},
			columns: {
				event: "Event",
				provider: "Processor",
				kind: "Kind",
				eventType: "Event type",
				reference: "Reference",
				status: "Status",
				attempts: "Attempts",
				reason: "Reason",
				received: "Received",
				settled: "Settled or parked",
				actions: "Action"
			},
			noReason: "—",
			noEventType: "—",
			retry: {
				action: "Retry",
				running: "Retrying…",
				confirmTitle: "Run this callback again?",
				confirmBody: "The drain re-reads reference {{reference}} and completes whatever it describes — which can write ledger entries, release escrow or ask the processor for a refund. Do this once the reason it parked has been fixed, not before. It is recorded against your account.",
				confirm: "Retry",
				landed: {
					PROCESSED: "Settled.",
					NEEDS_REVIEW: "It parked again — the cause has not been fixed yet.",
					PENDING: "Queued. The drain will pick it up.",
					FAILED: "It failed again."
				},
				failed: "The retry could not be started."
			},
			redrive: {
				action: "Redrive dead-lettered",
				running: "Redriving…",
				confirmTitle: "Redrive dead-lettered callbacks?",
				confirmBody: "Every message parked on payment.webhook_inbox is republished for the drain to try again. A callback that already settled is a no-op; a parked row is not reached by this at all — use Retry on the row instead.",
				confirm: "Redrive",
				done_one: "Redrove {{count}} message.",
				done_other: "Redrove {{count}} messages.",
				failed: "Redrive failed.",
				nothing: "Nothing is parked on the broker queue."
			},
			empty: {
				title: "Nothing has arrived yet",
				body: "Neither processor has sent a callback to this environment. That is the expected state until a payment is taken."
			},
			filtered: {
				title: "Nothing matched",
				body: "No captured callback matches these filters."
			}
		},
		routingTelemetry: {
			title: "Routing telemetry",
			subtitle: "How rarely the routing engine is confidently wrong: declines that followed a routed decision, beside the ambiguous and no-signal decisions the picker handled.",
			aggregateNotice: "Aggregates only. There is no per-payer view here and no filter narrow enough to produce one — a routing decision is derived from signals that are themselves personal data.",
			window: {
				label: "Window",
				days_one: "{{count}} day",
				days_other: "{{count}} days"
			},
			stats: {
				totalDecisions: "Decisions",
				totalDecisionsHint: "Routing decisions recorded in the window",
				routedShare: "Routed",
				routedShareHint: "Certainty cleared the threshold with a clear majority",
				declineRateRouted: "Decline rate — routed",
				declineRateRoutedHint: "Of routed decisions with a captured attempt, the share that declined — the confidently-wrong metric",
				ambiguousShare: "Ambiguous",
				ambiguousShareHint: "Signals reported, but not confidently or not in agreement",
				noSignalShare: "No signal",
				noSignalShareHint: "Nothing reported at all"
			},
			refresh: "Refresh",
			refreshing: "Refreshing…",
			table: {
				title: "Outcome × certainty band",
				columns: {
					outcome: "Outcome",
					certaintyBand: "Certainty band",
					decisions: "Decisions",
					attempted: "Attempted",
					declined: "Declined",
					settled: "Settled",
					overridden: "Overridden",
					declineRate: "Decline rate"
				}
			},
			noData: "—",
			empty: {
				title: "No routing decisions in this window",
				body: "Nothing was recorded between {{from}} and {{to}}. Widen the window above to see more history."
			},
			error: {
				title: "Couldn't load routing telemetry",
				body: "The payment service didn't answer.",
				retry: "Retry"
			}
		},
		payoutAttachments: {
			title: "Transfer receipts",
			attach: "Attach receipts",
			hint: "JPEG, PNG or WebP images up to {{size}}, at most {{max}} per payout. A PDF receipt must be exported as an image first.",
			full: "This payout already carries the maximum of {{max}} receipts.",
			uploading: "Uploading {{percent}}%",
			failedHint: "Could not be processed. Remove it and attach it again.",
			processingBlocksPaid: "Mark Paid is available once every receipt has finished processing.",
			confirmRemove: "Delete this receipt for good?",
			removed: "Receipt deleted",
			empty: {
				title: "No receipts",
				body: "Receipts are attached from Mark Paid while the payout is still requested."
			},
			file: {
				type: "{{name}} is not a JPEG, PNG or WebP image.",
				tooLarge: "{{name}} is larger than {{size}}.",
				tooSmall: "{{name}} is too small to be a receipt.",
				unknownSize: "{{name}} could not be read. Save it to this device and try again."
			},
			errors: {
				attachments_processing: "A receipt is still processing. Wait for it to finish, then mark the payout paid.",
				not_configured: "Receipt uploads are not available in this environment.",
				attachment_limit_reached: "This payout already carries the maximum of {{max}} receipts.",
				payout_request_not_open: "Receipts can only be attached while the payout is still requested.",
				attachment_not_ready: "This receipt has not finished processing.",
				attachment_destroy_failed: "The receipt could not be deleted. Try again.",
				generic: "Something went wrong with this receipt. Try again."
			}
		}
	},
	payoutAttachments: {
		title: "Transfer receipts",
		receipt: "Receipt {{number}}",
		addedOn: "Added {{date}}",
		view: "View",
		opening: "Opening…",
		openFailed: "Could not open this receipt",
		empty: {
			title: "No receipts attached",
			body: "This payout was marked paid without a transfer receipt."
		}
	}
};
//#endregion
export { e as default };
